import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const BagLabelState = Immutable.fromJS({
  bagLabel: {
    orderId: '',
    ordererIdFrom: 1,
    ordererIdTo: 9999,
    outputFile: '',
    outputFile2: ''
  },
  bagLabelValidation: {
    ordererIdFrom: {
      validationState: null,
      helpBlock: null
    },
    ordererIdTo: {
      validationState: null,
      helpBlock: null
    }
  },
  alertStyle: null,
  alertMessage: null
});

const bagLabelReducer = handleActions({
  CHANGE_LABEL_ORDERID: (state, { payload }) => {
    let bagLabel = state.get('bagLabel');
    return state.merge({
      bagLabel: bagLabel.set('orderId', payload.orderId),
    })
  },
  CHANGE_BAGLABEL_VALUE: (state, { payload }) => {
    let bagLabel = state.get('bagLabel');
    return state.merge({
      bagLabel: bagLabel.set(payload.id, payload.value),
    })
  },
  BEFORE_GENERATE_BAGLABEL: (state, { payload }) => {
    return state.merge({
      bagLabel: {
        outputFile: '',
        outputFile2: ''
      },
      alertStyle: null,
      alertMessage: '資料處理中，請稍後。'
    });
  },
  AFTER_GENERATE_BAGLABEL: (state, { payload }) => {
    return state.merge({
      bagLabel: payload.data.bean,
      bagLabelValidation: payload.data.valBean,
      alertStyle: payload.data.alertStyle,
      alertMessage: payload.data.alertMessage,
    })
  },
  CLEAN_BAGLABEL_ALERT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			bagLabelValidation: {}
		})
	}
}, BagLabelState);

export default bagLabelReducer;


// WEBPACK FOOTER //
// ./src/reducers/bagLabelReducer.js